

































































import { AconexImportDialogParams } from '@/components/documents/aconex-import-dialog/aconex-import-dialog-models';
import {
  AddEditDialogMode,
  AddEditDocumentDialogParams,
  AddEditDocumentDialogResult,
} from '@/components/documents/add-edit-document-dialog/add-edit-document-dialog-models';
import {
  CreateDocumentAssociationsDialogParams,
  CreateDocumentAssociationsDialogResult,
} from '@/components/documents/create-document-associations/create-document-associations-models';
import {
  SelectDocumentDialogParams,
  SelectDocumentDialogResult,
} from '@/components/documents/select-document-dialog/select-document-dialog-models';
import OtButton from '@/components/global/ot-button.vue';
import OtClaimRecommendationOverruleDialog, {
  ClaimRecommendationOverruleDialogParams,
  OverruleStateEnum,
} from '@/components/specific-modals/ot-claim-recommendation-overrule-dialog.vue';
import OtClaimSuspensionDialog from '@/components/specific-modals/ot-claim-suspension-dialog.vue';
import OtEmailContractorDialog, {
  EmailContractorDialogParams,
} from '@/components/specific-modals/ot-email-contractor-dialog.vue';
import OtRequestContractDialog from '@/components/specific-modals/ot-request-contract-dialog.vue';
import OtResetContractDateForPcDialog from '@/components/specific-modals/ot-reset-contract-date-for-pc-dialog.vue';
import OtStartRfiOutboundDialog from '@/components/specific-modals/ot-start-rfi-outbound-dialog.vue';
import { doAconexImport } from '@/services/aconex.service';
import {
  AconexDocumentMetadataModel as ApiAconexDocumentMetadataModel,
  AconexMailMetadataAttachmentsModel as ApiAconexMailMetadataAttachmentsModel,
  AconexMailMetadataLocalFileAttachmentModel,
  AconexMailMetadataModel as ApiAconexMailMetadataModel,
  AconexMailMetadataRecipientModel as ApiAconexMailMetadataRecipientModel,
  AconexMailMetadataRegisteredDocumentAttachmentModel,
  AconexMailMetadataUserDetailsModel as ApiAconexMailMetadataUserDetailsModel,
} from '@/services/generated/api';
import { vxm } from '@/store';
import { ZonelessDate } from '@/types/zoneless-date';
import { Component, Ref, Vue } from 'vue-property-decorator';

@Component({
  components: {
    OtButton,
    OtClaimSuspensionDialog,
    OtClaimRecommendationOverruleDialog,
    OtEmailContractorDialog,
    OtStartRfiOutboundDialog,
    OtResetContractDateForPcDialog,
    OtRequestContractDialog,
  },
})
export default class OtSpecificModalsWrapper extends Vue {
  // * PROPS

  // * REFS
  @Ref('claimSuspensionDialogRef') private readonly claimSuspensionDialogRef!: OtClaimSuspensionDialog;
  @Ref('emailContractorDialogRef') private readonly emailContractorDialogRef!: OtEmailContractorDialog;
  @Ref('claimRecommendationOverruleDialogRef')
  private readonly claimRecommendationOverruleDialogRef!: OtClaimRecommendationOverruleDialog;
  @Ref('startRfiOutboundDialogRef') private readonly startRfiOutboundDialogRef!: OtStartRfiOutboundDialog;
  @Ref('resetContractDateForPcDialogRef')
  private readonly resetContractDateForPcDialogRef!: OtResetContractDateForPcDialog;
  @Ref('requestContractDialogRef')
  private readonly requestContractDialogRef!: OtRequestContractDialog;

  // * DATA
  private result: unknown = null;

  // * COMPUTED

  // * WATCHERS

  // * METHODS
  private async openClaimSuspensionDialog() {
    this.result = await this.claimSuspensionDialogRef.open();
  }

  private async openClaimRecommendationOverruleDialog() {
    const params = new ClaimRecommendationOverruleDialogParams('Notice Name', OverruleStateEnum.ValidToInvalid, 2);
    this.result = await this.claimRecommendationOverruleDialogRef.open(params);
  }

  private async openEmailContractorDialog() {
    const profile = vxm.userProfile.userProfile;
    const params = new EmailContractorDialogParams();
    params.emailContent = 'this is the <b>body</b>';
    params.emailSubject = 'this is the subject';
    params.readonly = false;
    params.recipientEmails = [profile?.email || 'profile-has-no-email-address@mailinator.org'];
    this.result = await this.emailContractorDialogRef.open(params);
  }

  private async openStartRfiOutboundDialog() {
    this.result = await this.startRfiOutboundDialogRef.open();
  }

  private async openResetContractDateForPcDialog() {
    this.result = await this.resetContractDateForPcDialogRef.open({
      contractGid: '6',
      contractReference: 'C42x',
      contractName: 'Some Contract Name',
      dateOfContract: new ZonelessDate('2023-01-01'),
      mostRecentlyAgreedDateForPracticalCompletion: null,
      projectedCompletionDate: new ZonelessDate('2023-12-31'),
      revisedCompletionDate: null,
      adjustedProjectCompletionDate: new ZonelessDate('2024-01-02'),
      contractRowVersion: '42',
    });
  }

  private async openRequestContractDialog() {
    this.result = await this.requestContractDialogRef.open({
      projectGid: '91deea01-97ac-4d66-b68e-03b7bc86e630', // metro tunnel from SC100
    });
  }

  private addDocumentResult: AddEditDocumentDialogResult | null = null;
  private async openAddDocumentDialog() {
    this.addDocumentResult = await vxm.modal.openAddEditDocumentDialog(
      new AddEditDocumentDialogParams({
        context: 'The Thing',
        targetOrganisationGid: '54EAC053-D709-47B2-9A6D-142B49F42DF6', // OneTrack from SC100
        mode: AddEditDialogMode.Create,
      }),
    );
  }
  private async openAddAconexDocumentDialog() {
    this.addDocumentResult = await vxm.modal.openAddEditDocumentDialog(
      new AddEditDocumentDialogParams({
        context: 'The Thing',
        targetOrganisationGid: '54EAC053-D709-47B2-9A6D-142B49F42DF6', // OneTrack from SC100
        mode: AddEditDialogMode.Create,
        aconexProjectId: '31618',
        aconexDocument: new ApiAconexDocumentMetadataModel({
          documentId: '1678716762418543077',
          documentNumber: 'SPEC-000003',
          author: 'Sum Yang Gai',
          title: 'The Title',
          revision: '1.0_final',
          comments: 'this is some comments about the document',
          dateModifiedUtc: new Date('2024-08-19T01:15:39.638+00:00'),
          documentType: 'Specification',
          fileSize: 534448,
          filename: 'oracle_aconex_mail_developer_guide_may_2023.docx',
          fileType: undefined,
          versionNumber: 1,
          trackingId: '1678716761195228680',
        }),
      }),
    );
  }
  private async openAddAconexMailDialog() {
    this.addDocumentResult = await vxm.modal.openAddEditDocumentDialog(
      new AddEditDocumentDialogParams({
        context: 'The Thing',
        targetOrganisationGid: '54EAC053-D709-47B2-9A6D-142B49F42DF6', // OneTrack from SC100
        mode: AddEditDialogMode.Create,
        aconexProjectId: '31618',
        aconexMail: new ApiAconexMailMetadataModel({
          mailId: '1608024606',
          correspondenceType: 'General Correspondence',
          toUsers: [
            new ApiAconexMailMetadataRecipientModel({
              status: 'N/A',
              distributionType: 'TO',
              organizationId: '1476508772',
              organizationName: 'CATIPCo Pty Ltd',
              userId: '1477321053',
              name: 'Scott Rapsey',
            }),
          ],
          mailNo: 'REDGUM-GCOR-000001',
          fromUserDetails: new ApiAconexMailMetadataUserDetailsModel({
            organizationId: '1476508498',
            organizationName: 'Redgum Technologies',
            userId: '1477283267',
            name: 'Mr Paul Johanson',
          }),
          reasonForIssue: '',
          sentDateUtc: new Date('2022-12-19T01:25:56.08+00:00'),
          status: 'N/A',
          subject: 'Re: Test to see if we can keep the Redgum account alive',
          confidentialFlag: 0,
          attachments: new ApiAconexMailMetadataAttachmentsModel({
            localFileAttachments: [
              new AconexMailMetadataLocalFileAttachmentModel({
                attachmentId: 'attachmentId456',
                fileName: 'fileName456',
                fileSize: 456,
              }),
            ],
            mailAttachments: [],
            registeredDocumentAttachments: [
              new AconexMailMetadataRegisteredDocumentAttachmentModel({
                attachmentId: 'attachmentId123',
                confidential: false,
                documentId: 'documentId123',
                documentNo: 'documentNo123',
                fileName: 'fileName123',
                fileSize: 123,
                revision: 'revision123',
                revisionDateUtc: new Date('2024-01-01T00:00:00.000Z'),
                status: 'status123',
                title: 'title123',
              }),
            ],
          }),
          fax: '',
          faxLog: false,
          footer: '',
          links: [],
          mailData: 'the mail data',
          notes: [],
          projectId: '31618',
          richMailText: true,
          threadId: '',
          approvalStatus: undefined,
          projectDetails: undefined,
          responseRequired: undefined,
        }),
      }),
    );
  }
  private async openEditDocumentDialog() {
    const params = new AddEditDocumentDialogParams({
      context: 'The Thing That Should Not Be Visible On Screen',
      targetOrganisationGid: '54EAC053-D709-47B2-9A6D-142B49F42DF6', // OneTrack from SC100
      documentGid: '00000000-0000-0000-0000-000000000000', // yeah, doesn't exist
      mode: AddEditDialogMode.Edit,
    });
    this.addDocumentResult = await vxm.modal.openAddEditDocumentDialog(params);
  }

  private createAssociationsResult: CreateDocumentAssociationsDialogResult | null = null;
  private async openCreateDocumentAssociationsDialog() {
    const params = new CreateDocumentAssociationsDialogParams({
      documentGid: '00000000-0000-0000-0000-000000000000', // yeah, doesn't exist
      targetOrganisationGid: '54EAC053-D709-47B2-9A6D-142B49F42DF6', // OneTrack from SC100
      addToOrganisation: false,
      addToProjectGids: [],
      addToContractGids: [],
    });

    this.createAssociationsResult = await vxm.modal.openCreateDocumentAssociationsDialog(params);
  }

  private selectDocumentResult: SelectDocumentDialogResult | null = null;
  private async openSelectDocumentDialog() {
    const params = new SelectDocumentDialogParams({
      targetOrganisationGid: '54EAC053-D709-47B2-9A6D-142B49F42DF6', // OneTrack from SC100
      context: 'The Thing That Should Not Be Visible On Screen',
    });
    this.selectDocumentResult = await vxm.modal.openSelectDocumentDialog(params);
  }

  private aconexResult: unknown = null;
  private async doAconexImport() {
    const documentParams = new AddEditDocumentDialogParams({
      context: 'The Thing',
      targetOrganisationGid: '54EAC053-D709-47B2-9A6D-142B49F42DF6', // OneTrack from SC100
      mode: AddEditDialogMode.Create,
    });

    this.aconexResult = await doAconexImport(new AconexImportDialogParams({ documentParams }));
  }

  // * LIFECYCLE
}
